<template>
  <v-autocomplete
    label="Kunde"
    name="customer"
    ref="customerSelectbox"
    v-bind="$attrs"
    v-model="selected"
    :search-input.sync="searchCustomers"
    :loading="loading"
    :items="customersList"
    return-object
  >
    <template v-slot:append-outer>
      <v-chip small dense>
        {{ customersList ? customersList.length : 0 }}
      </v-chip>
    </template>
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title> Kundenamen zum suchen eingeben </v-list-item-title>
      </v-list-item>
    </template>
    <template v-slot:item="{ item }">
      <v-list-item-content v-if="item && item.value.kdnr">
        <v-list-item-title
          >{{ item.value.kdnr }} - {{ item.text }}</v-list-item-title
        >
        <v-list-item-subtitle
          >{{ item.value.adresse }} / {{ item.value.plz }}
          {{ item.value.ort }}</v-list-item-subtitle
        >
      </v-list-item-content>
      <v-list-item-content v-else>
        <v-list-item-title>Alle</v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "CustomerSelectbox",
  props: ["value", "showAll"],
  /* props: {
    value: {
      type: [Object, String],
      required: false,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
  },*/
  data: () => ({
    initial: false,
    selected: null,
    loading: false,
    searchCustomers: null,
    customersList: []
  }),
  computed: {
    customers() {
      return this.$store.getters["customer/getCustomerList"];
    }
  },
  methods: {
    loadCustomers() {
      let foundItems = [];
      if (this.showAll) {
        foundItems.push({ text: "Alle", value: "all" });
      }

      this.customers.forEach(item => {
        foundItems.push({ text: item.name, value: item });
      });

      this.customersList = foundItems;
    },
    updateSelected(val) {
      // console.log(val);
      if (!val) {
        return false;
      } else if (val === "all") {
        this.selected = this.customersList[0];
      }

      //  console.log("search", val, this.customersList);
      let foundIndex = this.customersList.findIndex(
        el => el.value._id == val._id
      );
      // console.log("found", foundIndex);
      if (foundIndex >= 0) {
        this.selected = this.customersList[foundIndex];
      } else {
        //this.customersList = [{ text: val.name, value: val }];
        this.selected = { text: val.name, value: val };
      }
    }
  },

  watch: {
    customers() {
      this.loadCustomers();
    },
    value(val) {
      this.updateSelected(val);
    },
    selected(value) {
      if (value === "all" && this.showAll) {
        this.$emit("input", value);
      } else {
        this.$emit("input", value ? value.value : null);
      }
    },
    searchCustomers() {
      /* if (this.loading == true) {
        return;
      }


      if ((name && name.length < 3) || this.initial) {
        return;
      }
      if (name && (!this.selected || this.selected.text !== name)) {
        this.loading = true;
        let foundItems = [];
        CustomerService.findByName(name)
          .then((result) => {
            result.data.data.forEach((item) => {
              foundItems.push({ text: item.name1, value: item });
            });
          })
          .catch((error) => {
            foundItems = [];
            if (error.response.status != 401) {
              this.$notify({
                group: "dataline",
                type: "error",
                title: "Fehler",
                text: error.message,
              });
            }
          })
          .finally(() => {
            this.loading = false;
            this.customersList = foundItems;
          });
      }
      */
    }
  },

  created() {
    this.loadCustomers();
    //  console.log("created", this.value);
    this.updateSelected(this.value);
  }
};
</script>
